/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  class HeaderState {
    constructor() {
      this.header = document.querySelector('header-component');
      this.drawerBody = document.querySelector('.drawer__body');
      this.announcementBar = document.querySelector('announcement-bar');
      this.isStuck = false;
      this.isMobile = window.innerWidth < 750;

      this.init();
    }

    init() {
      if (!this.header || !this.drawerBody || !this.isMobile) return;

      this.updateState();
      this.updateDrawerMargin();

      this.observer = new MutationObserver(() => {
        if (!this.isMobile) return;
        this.updateState();
        this.updateDrawerMargin(); 
      });
      
      this.observer.observe(this.header, {
        attributes: true,
        attributeFilter: ['class']
      });

      window.addEventListener('scroll', () => {
        if (!this.isMobile) return;
        this.updateState();
        this.updateDrawerMargin();
      });

      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 750;
        if (!this.isMobile) {
          this.drawerBody.style.marginTop = '0px';
          return;
        }
        this.updateState();
        this.updateDrawerMargin();
      });
    }

    updateState() {
      if (!this.isMobile) return;
      this.isStuck = this.header.classList.contains('js__header__stuck');
    }

    getAnnouncementBarHeight() {
      if (!this.announcementBar || !this.isMobile) return 0;
      
      if (this.isStuck) return 0;
      
      const rect = this.announcementBar.getBoundingClientRect();
      return rect.height;
    }

    updateDrawerMargin() {
      if (!this.isMobile) return;
      const announcementHeight = this.getAnnouncementBarHeight();
      const baseMargin = 0;
      const totalMargin = baseMargin + announcementHeight;
      
      this.drawerBody.style.marginTop = `${totalMargin}px`;
    }
  }
  new HeaderState();
  
  function initQuickAddVariantSelection() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuickAddVariantSelection);
      return;
    }

    document.addEventListener('change', (e) => {
      if (!e.target.classList.contains('size-option') || e.target.type !== 'radio') return;
      if (!e.target.checked || e.target.disabled) return;

      const form = e.target.closest('.quick-add__form');
      if (!form) return;

      const buttonText = form.querySelector('[data-add-to-cart-text]');
      const button = form.querySelector('[data-add-to-cart]');
      const selectedVariantTitle = form.querySelector('.selected-size-text');
      const label = form.querySelector(`label[for="${e.target.id}"]`);
      const variantTitle = label ? label.textContent.trim() : '';

      if (selectedVariantTitle) {
        selectedVariantTitle.textContent = variantTitle;
      }

      if (buttonText && window.theme && window.theme.strings) {
        buttonText.textContent = window.theme.strings.addToCart || 'Add to cart';
      }

      if (button) {
        button.disabled = false;
      }
    });

    setTimeout(() => {
      const forms = document.querySelectorAll('.quick-add__form');
      forms.forEach((form) => {
        const buttonText = form.querySelector('[data-add-to-cart-text]');
        const button = form.querySelector('[data-add-to-cart]');
        const checkedRadio = form.querySelector('.size-option[type="radio"]:checked');

        if (!buttonText || !button) return;

        if (!checkedRadio) {
          if (buttonText && window.theme && window.theme.strings) {
            buttonText.textContent = window.theme.strings.selectSize || 'Select size';
          }
          if (button) {
            button.disabled = true;
          }
        }
      });
    }, 100);
  }

  initQuickAddVariantSelection();

   if (document.body.classList.contains('template-product')) {
    window.addEventListener('scroll', () => {
      const cartBar = document.querySelector('#cart-bar');
      const windowHeight = window.innerHeight;

      const footer = document.querySelector('.site-footer-wrapper');
      const footerTop = footer.getBoundingClientRect().top;

      const overLap = windowHeight - footerTop;

      if (overLap > 0) {
        cartBar.style.opacity = '0';
        cartBar.style.transition = 'opacity .3s ease';
      } else {
        cartBar.style.opacity = '';
        cartBar.style.transition = '';
      }
    });
  }


  const initPreorderDrawers = (scope = document) => {
    scope.querySelectorAll('[data-preorder-drawer-toggle]')?.forEach((toggle) => {
      if (toggle.dataset.drawerBound === 'true') return;

      const drawerKey = toggle.getAttribute('data-preorder-drawer-toggle');
      const drawer = document.querySelector(`[data-drawer="${drawerKey}"]`);

      toggle.dataset.drawerBound = 'true';

      if (!drawer) return;

      const handleToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();

        drawer.dispatchEvent(
          new CustomEvent('theme:drawer:toggle', {
            bubbles: false,
            detail: {
              button: toggle,
            },
          })
        );
      };

      toggle.addEventListener('click', handleToggle);
      
      // Handle keyboard events for accessibility
      toggle.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleToggle(event);
        }
      });
    });
  };

  initPreorderDrawers();
  document.addEventListener('shopify:section:load', (event) => initPreorderDrawers(event.target));

  // Ensure size guide and preorder drawer content is scrollable when scroll lock is active
  (function() {
    const processedDrawers = new Set(); // Track which drawers we've already processed

    const ensureDrawerContentIsScrollable = (drawer) => {
      // Find the scrollable content areas - both drawer__body and drawer__content__scroll
      const drawerBody = drawer.querySelector('.drawer__body');
      const scrollableContent = drawer.querySelector('.drawer__content__scroll');
      
      // Add attribute to drawer__body (the main scrolling container)
      if (drawerBody) {
        drawerBody.setAttribute('data-scroll-lock-scrollable', '');
      }
      
      // Also add to drawer__content__scroll if it exists
      if (scrollableContent) {
        scrollableContent.setAttribute('data-scroll-lock-scrollable', '');
      }
    };

    const setupDrawerListeners = (drawer) => {
      // Skip if already set up
      if (processedDrawers.has(drawer)) return;
      processedDrawers.add(drawer);

      // Ensure scrollable attribute is set initially
      ensureDrawerContentIsScrollable(drawer);

      // Also ensure it's set when drawer opens (in case content is dynamically loaded)
      drawer.addEventListener('theme:drawer:open', () => {
        ensureDrawerContentIsScrollable(drawer);
      });
    };

    const initDrawerScrollability = () => {
      // Find size guide drawer (static data-drawer="sizeguide")
      const sizeGuideDrawer = document.querySelector('[data-drawer="sizeguide"]');
      
      // Find all preorder drawers (dynamic data-drawer starting with "preorder-")
      const preorderDrawers = document.querySelectorAll('[data-drawer^="preorder-"]');
      
      // Set up size guide drawer
      if (sizeGuideDrawer) {
        setupDrawerListeners(sizeGuideDrawer);
      }
      
      // Set up all preorder drawers
      preorderDrawers.forEach(drawer => {
        setupDrawerListeners(drawer);
      });
    };

    // Initialize on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initDrawerScrollability();
      });
    } else {
      initDrawerScrollability();
    }

    // Re-initialize on section reload (Shopify theme editor)
    document.addEventListener('shopify:section:load', () => {
      initDrawerScrollability();
    });
  })();
  // Cart delivery price update
  function initCartDeliveryPrice() {
    const deliveryEl = document.querySelector('[data-cart-delivery]');
    if (!deliveryEl) return;

    const deliveryPriceEl = deliveryEl.querySelector('[data-delivery-price]');
    if (!deliveryPriceEl) return;

    const deliveryPrice = parseFloat(deliveryEl.getAttribute('data-delivery-price')) || 29;
    const freeShippingLimit = parseFloat(deliveryEl.getAttribute('data-free-shipping-limit')) || 200;
    const freeShippingLimitCents = freeShippingLimit * 100 * (window.Shopify?.currency?.rate || 1);
    const deliveryPriceCents = deliveryPrice * 100;
    const freeText = window.theme?.strings?.free || 'Free';
    const useCurrencyCode = window.theme?.settings?.currency_code_enable || false;

    function checkIfAllGiftCards() {
      const cartItems = document.querySelectorAll('[data-item]');
      // If no cart items, show delivery (not all gift cards)
      if (cartItems.length === 0) return false;
      
      // Check if ALL items are gift cards
      // Return true only if ALL items have the gift card attribute
      for (let i = 0; i < cartItems.length; i++) {
        if (!cartItems[i].hasAttribute('data-is-gift-card')) {
          // Found a non-gift-card item, so not all are gift cards
          return false;
        }
      }
      
      // All items are gift cards
      return true;
    }

    function updateDelivery() {
      // Only proceed if delivery element exists
      if (!deliveryEl) return;
      
      // Check if all items are gift cards
      const allGiftCards = checkIfAllGiftCards();
      
      const cartTotal = document.querySelector('[data-cart-total]');
      if (!cartTotal) return;

      const subtotal = parseInt(cartTotal.getAttribute('data-cart-total')) || 0;

      // If all items are gift cards, show "Free" for delivery
      if (allGiftCards) {
        deliveryPriceEl.textContent = freeText;
        // Don't add shipping cost for gift cards
        if(cartTotal.hasAttribute('data-cart-total-with-shipping')) {
          cartTotal.setAttribute('data-cart-total-with-shipping', subtotal);
        }
        const format = useCurrencyCode ? theme.moneyWithCurrencyFormat : theme.moneyFormat;
        if(subtotal === 0) {
          cartTotal.textContent = freeText;
        } else {
          cartTotal.textContent = window.theme.formatMoney(subtotal, format);
        }
        return;
      }

      // Regular delivery calculation for non-gift-card items
      if (subtotal >= freeShippingLimitCents) {
        deliveryPriceEl.textContent = freeText;
      } else {
        const format = useCurrencyCode ? theme.moneyWithCurrencyFormat : theme.moneyFormat;
        deliveryPriceEl.textContent = window.theme.formatMoney(deliveryPriceCents, format);
      }

      let shippingCost = 0;
      if(subtotal < freeShippingLimitCents) {
        shippingCost = deliveryPriceCents;
      }

      const subtotalWithShipping = subtotal + shippingCost;

      if(cartTotal.hasAttribute('data-cart-total-with-shipping')) {
        cartTotal.setAttribute('data-cart-total-with-shipping', subtotalWithShipping);
      }

      const format = useCurrencyCode ? theme.moneyWithCurrencyFormat : theme.moneyFormat;
      if(subtotalWithShipping === 0) {
        const freeText = window.theme?.strings?.free || 'Free';
        cartTotal.textContent = freeText;
      } else {
        cartTotal.textContent = window.theme.formatMoney(subtotalWithShipping, format);
      }
    }

    document.addEventListener('theme:cart:change', updateDelivery);
    document.addEventListener('theme:product:added', updateDelivery);
    
    const cartTotal = document.querySelector('[data-cart-total]');
    if (cartTotal) {
      new MutationObserver(updateDelivery).observe(cartTotal, {
        attributes: true,
        attributeFilter: ['data-cart-total']
      });
    }

    // Also observe cart items changes
    const cartItemsContainer = document.querySelector('[data-items-holder]');
    if (cartItemsContainer) {
      new MutationObserver(() => {
        setTimeout(updateDelivery, 100);
      }).observe(cartItemsContainer, {
        childList: true,
        subtree: true
      });
    }

    updateDelivery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDeliveryPrice);
  } else {
    initCartDeliveryPrice();
  }

// Geolocation: preselect suggested country (Shopify endpoint)
document.addEventListener('DOMContentLoaded', function() {
  var countriesEl = document.querySelector('[data-countries-list]');
  if (!countriesEl) return;
  var countries = [];
  try { countries = JSON.parse(countriesEl.textContent); } catch(e) {}

  // Shopify suggestion endpoint
  fetch('/browsing_context_suggestions.json')
    .then(function(res){ return res.json(); })
    .then(function(data){
      var iso = (data && data.detected_values && data.detected_values.country) ? data.detected_values.country.toUpperCase() : null;
      if (!iso) return;

      // Find matching country in the configured list
      var match = countries.find(function(c){ return c.isoCode.toUpperCase() === iso; });
      if (!match) return;

      // Store suggestion for later use (redirect or close behavior)
      localStorage.setItem('geoSuggestedIso', match.isoCode);

      // Optional: highlight suggested flag
      document.querySelectorAll('.CountrySelect__flag-link').forEach(function(link){
        var title = (link.getAttribute('title') || '').toUpperCase();
        var label = (link.querySelector('.CountrySelect__flag-label')?.textContent || '').toUpperCase();
        if (title === match.languageName?.toUpperCase() || label === match.languageName?.toUpperCase() || title === match.isoCode?.toUpperCase()) {
          link.setAttribute('data-suggested-country', 'true');
          link.style.outline = '2px solid #111';
        }
      });
    })
    .catch(function(){});
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
